import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { UserService } from 'src/app/services/user.service';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-colaboradores',
  templateUrl: './colaboradores.component.html',
  styleUrls: ['./colaboradores.component.css']
})
export class ColaboradoresComponent implements OnInit {
  isOK = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  cadastroFrm: cadastroData = {
    loading: false,
    data: {
      escritorio: -1,
      nome: '',
      cpf: '',
      crc: '',
      validade: '',
      email: '',
      senha: '',
      permissoes: []
    }
  }

  modalCadastrar: any;

  editarFrm: editarData = {
    loading: false,
    data: {
      id: -1,
      escritorio: -1,
      nome: '',
      cpf: '',
      crc: '',
      validade: '',
      email: '',
      permissoes: []
    }
  }

  modalEditar: any;

  options1!: Options;
  options2!: Options;

  public grupoData1 = [
    {
      id: 'dyn1',
      text: 'Dynamic 1',
    }
  ];

  constructor(public userService: UserService, private router: Router, private elem: ElementRef) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('5')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.options1 = {
      allowClear: true,
      placeholder: 'Selecione um Escritório',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-escritorio',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
      dropdownParent: $('#cadastrar')
    };

    this.options2 = {
      allowClear: true,
      placeholder: 'Selecione um Escritório',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-escritorio',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
      dropdownParent: $('#editar')
    };

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
      ajax: {
        url: environment.apiEndpoint + 'colaboradores-list',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: function (d) {
          return JSON.stringify(d);
        },
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        error: (xhr: any, error: any, code: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        }
      },
      pageLength: 10,
      processing: false,
      serverSide: true,
      columnDefs: [
        { "searchable": false, "targets": [4] },
        { "orderable": false, "targets": [4] },
      ],
      order: [[1, 'asc']],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        const id = Number($('button:eq(0)', row).attr('row_id'));
        $('button:eq(0)', row).off('click');
        $('button:eq(0)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchColaborador(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = 'Editar';
          }
          call();
        });
        $('button:eq(1)', row).off('click');
        $('button:eq(1)', row).on('click', () => {
          this.Excluir(Number(id));
        });
        return row;
      },
    }

    this.modalCadastrar = new bootstrap.Modal(
      document.getElementById('cadastrar'),
      {
        backdrop: 'static',
      }
    );

    this.modalEditar = new bootstrap.Modal(
      document.getElementById('editar'),
      {
        backdrop: 'static',
      }
    );
  }

  Cadastrar() {
    this.cadastroFrm.data.permissoes = [];
    const elements = this.elem.nativeElement.querySelectorAll('.permissao');

    for (const index of elements) {
      if (index.checked) {
        this.cadastroFrm.data.permissoes.push(Number(index.value));
      }
    }

    this.cadastroFrm.loading = true;
    this.userService
      .cadastrarColaborador(
        this.cadastroFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Colaborador cadastrado',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.cadastroFrm.data = {
            escritorio: -1,
            nome: '',
            cpf: '',
            crc: '',
            validade: '',
            email: '',
            senha: '',
            permissoes: []
          };
          this.modalCadastrar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.cadastroFrm.loading = false
        },
        () => (this.cadastroFrm.loading = false)
      );
  }

  fetchColaborador(id: number) {
    this.editarFrm.loading = true;
    return new Promise((resolve) => {
      this.userService.fetchColaborador(id).subscribe(
        (res: any) => {
          this.editarFrm.data = res.data;

          const elements = this.elem.nativeElement.querySelectorAll(
            '.permissao2'
          );

          for (const index2 of elements) {
            index2.checked = false;
          }

          for (const index of res.data.permissoes) {
            for (const index2 of elements) {
              if (Number(index2.value) === Number(index)) {
                index2.checked = true;
                break;
              }
            }
          }

          this.grupoData1 = [];
          this.grupoData1.push(
            {
              id: res.data.escritorio,
              text: res.text
            }
          )
          this.modalEditar.show();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.editarFrm.loading = false
        },
        () => (this.editarFrm.loading = false)
      ).add(() => {
        resolve('');
      });
    });
  }

  Editar() {
    this.editarFrm.data.permissoes = [];
    const elements = this.elem.nativeElement.querySelectorAll('.permissao2');

    for (const index of elements) {
      if (index.checked) {
        this.editarFrm.data.permissoes.push(Number(index.value));
      }
    }

    this.editarFrm.loading = true;
    this.userService
      .editarColaborador(
        this.editarFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Colaborador editado',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.modalEditar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.editarFrm.loading = false
        },
        () => (this.editarFrm.loading = false)
      );
  }

  Excluir(id: number) {
    Swal.fire({
      title: 'Excluir Colaborador?',
      icon: 'warning',
      text: 'Este processo é irreversível',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.excluirColaborador(id).subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: 'Colaborador excluído',
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.ajax.reload();
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }
}

export interface cadastroData {
  loading: boolean;
  data: {
    escritorio: Number;
    nome: string;
    cpf: string;
    crc: string;
    validade: string;
    email: string;
    senha: string;
    permissoes: Number[]
  }
}

export interface editarData {
  loading: boolean;
  data: {
    id: Number;
    escritorio: Number
    nome: string;
    cpf: string;
    crc: string;
    validade: string;
    email: string;
    permissoes: Number[];
  }
}

